module.exports = __webpack_public_path__ + "static/img/img2.0014b4db.png";